import { generateActionForKey, generateActions } from "../generateActions";
import { eQuyDinhSoTinChiActionIds, eQuyDinhSoTinChiActionsObj } from "../../action-types/quan-ly-dang-ky/IQuyDinhSoTinChiActions";
import { NotifyHelper } from "../../../helpers/toast";

export const quyDinhSoTinChiActions = {
    ...generateActions(eQuyDinhSoTinChiActionsObj, "QUY_DINH_SO_TIN_CHI"),
    ...generateActionForKey(eQuyDinhSoTinChiActionsObj, "QUY_DINH_SO_TIN_CHI", "SUBMIT_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
    ...generateActionForKey(eQuyDinhSoTinChiActionsObj, "QUY_DINH_SO_TIN_CHI", "SUBMIT_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
    ...generateActionForKey(eQuyDinhSoTinChiActionsObj, "QUY_DINH_SO_TIN_CHI", "LOAD_BY_HOC_KY_NAM_HOC_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
}
